<template>
  <div>
    <div class="card">
      <div class="card-header"><h4 style="text-align: center">EMPRESA</h4></div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <label for="nome">Nome</label>
            <input
              id="nome"
              type="text"
              class="form-control"
              placeholder="Digite um nome:"
              v-model="state.nome"
            />
          </div>
          <div class="col-md-4">
            <label for="email">Email</label>
            <input
              id="email"
              type="email"
              class="form-control"
              placeholder="Insira um email:"
              v-model="state.email"
            />
          </div>
          <div class="col-md-4">
            <label for="whatsapp">Whatsapp</label>
            <input
              id="whatsapp"
              type="text"
              class="form-control"
              placeholder="Insira um horário de whatsapp:"
              v-model="state.whatsapp"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-8">
            <label for="endereco">Descrição do Site</label>
            <textarea
              id="endereco"
              type="text"
              class="form-control"
              placeholder=""
              v-model="state.endereco"
            ></textarea>
          </div>
          <div class="col-md-4">
            <label for="telefone">Telefone</label>
            <input
              id="telefone"
              type="text"
              class="form-control"
              placeholder="Número de endereço:"
              v-model="state.telefone"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-4">
            <label for="tiktok">Tiktok</label>
            <input
              id="tiktok"
              type="text"
              class="form-control"
              placeholder="Insira um tiktok:"
              v-model="state.tiktok"
            />
          </div>
          <div class="col-md-4">
            <label for="instagram">Instagram</label>
            <input
              id="instagram"
              type="text"
              class="form-control"
              placeholder="Insira um instagram:"
              v-model="state.instagram"
            />
          </div>
          <div class="col-md-4">
            <label for="youtube">Youtube</label>
            <input
              id="youtube"
              type="text"
              class="form-control"
              placeholder="Insira uma youtube:"
              v-model="state.youtube"
            />
          </div>
        </div>
        <div class="btns_right">
          <button @click="upEmpresa" type="button" class="btn_save">
            Salvar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      id: "",
      nome: "",
      email: "",
      celular: "",
      telefone: "",
    });
    onMounted(() => {
      fetchEmpresa();
    });
    async function fetchEmpresa() {
      try {
        const { data } = await services.empresa.getEmpresa({
          token,
        });
        state.nome = data.nome;
        state.email = data.email;
        state.atendimento = data.atendimento;
        state.instagram = data.instagram;
        state.tiktok = data.tiktok;
        state.youtube = data.youtube;
        state.whatsapp = data.whatsapp;
        state.telefone = data.telefone;
      } catch (error) {
        void error;
      }
    }
    async function upEmpresa() {
      let dados = {
        nome: state.nome,
        email: state.email,
        atendimento: state.atendimento,
        endereco: state.endereco,
        numero: state.numero,
        bairro: state.bairro,
        cep: state.cep,
        cidade: state.cidade,
        estado: state.estado,
        whatsapp: state.whatsapp,
        telefone: state.telefone,
        token,
      };
      try {
        await services.empresa.save(dados, token);
      } catch (error) {
        void error;
      }
    }
    return {
      upEmpresa,
      state,
    };
  },
};
</script>
<style scoped>
h4 {
  color: #000;
}
label {
  color: #000;
  font-size: 12pt;
  margin-bottom: 0;
  margin-top: 5px;
}
input {
  border: solid 1px #000;
}
input:focus {
  border: solid 1px #8b0000;
}
select {
  border: solid 1px #000;
}
select:focus {
  border: solid 1px #8b0000;
}
.btns_right {
  text-align: right;
}
.btn_save {
  padding: 5px;
  width: 100px;
  background: #00a000;
  border: solid 2px #000;
  border-radius: 5px;
  transition: 0.2s;
}
.btn_save:hover {
  background: #008000;
}
.btn_cancel {
  padding: 5px;
  width: 100px;
  background: #c4342d;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn_cancel:hover {
  background: #8f0303;
}
.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}
</style>